<template>
  <div>
    <div class="filter-container">
      <el-row :gutter="10">
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.report_number" placeholder="请输入检测报告编号" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.equipment_name" placeholder="请输入设备名称" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.client" placeholder="请输入委托单位" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <el-select v-model="listQuery.inspection_result" clearable placeholder="请选择检测结论">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
          搜索
        </el-button>
      </el-row>
    </div>

    <el-table
      ref="securityTable"
      v-loading="loading"
      :data="list"
      border
      style="width: 100%"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="report_number" label="报告编号" />
      <el-table-column prop="equipment_name" label="设备名称" />
      <el-table-column prop="equipment_model" label="设备型号" />
      <el-table-column prop="client" label="委托单位" />
      <el-table-column prop="equipment_number" label="设备号牌" />
      <el-table-column label="检测结论">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.inspection_result" type="info">未检测</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '合格'" type="success">{{ scope.row.inspection_result }}</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '不合格'" type="danger">{{ scope.row.inspection_result }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="inspection_date" label="检测日期" />
      <el-table-column label="当前状态">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.stage" type="success" effect="dark">待检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 1" type="success">已检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 2" type="warning" effect="dark">待审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 3" type="warning">已审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 4" effect="dark">待批准</el-tag>
          <el-tag v-else-if="scope.row.stage === 5">已批准</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" />
      <el-table-column align="left" label="操作" width="320">
        <template slot-scope="scope">
          <el-button
            v-waves
            size="mini"
            type="info"
            :disabled="!checkPermission(['larke-admin.cert.detail'])"
            @click="handleDetail(scope.row)"
          >
            详情
          </el-button>
          <el-button
            v-waves
            size="mini"
            type="primary"
            :disabled="!checkPermission(['larke-admin.cert.update'])"
            @click="handleEditSecurity(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            v-waves
            size="mini"
            type="danger"
            :disabled="!checkPermission(['larke-admin.cert.delete'])"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
          <el-button
            v-waves
            size="mini"
            type="success"
            :disabled="!checkPermission(['larke-admin.cert.print'])"
            @click="handlePrint(scope.row)"
          >
            打印
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="handleTable"
    />

    <!--  预览安全检验报告  -->
    <el-dialog
      title="预览安全检验报告"
      :visible.sync="preview.dialogVisible"
      width="70%"
    >
      <preview-security :item="preview" />
    </el-dialog>

    <!-- 编辑安全检验报告  -->
    <el-dialog
      title="编辑安全检验报告"
      :visible.sync="editSecurity.dialogVisible"
      width="1300px"
    >
      <edit-security :item="editSecurity" @success:edit="handleEditSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves'
import checkPermission from '@/utils/permission'
import permission from '@/directive/permission'
import { listSecurity } from '@/api/cert'
import { deleteSecurity } from '@/api/verification'
import Pagination from '@/components/Pagination'
import PreviewSecurity from '@/views/cert/Components/PreviewSecurity.vue'
import EditSecurity from '@/views/verification/Components/EditSecurity.vue'

export default {
  name: 'CertSecurity',
  components: { EditSecurity, PreviewSecurity, Pagination },
  directives: { waves, permission },
  data() {
    return {
      loading: false,
      preview: {
        dialogVisible: false,
        id: 0,
        data: {},
        isPrint: false,
        showRecord: true
      },
      editSecurity: {
        dialogVisible: false,
        id: 0
      },
      total: 0,
      list: [],
      options: [
        { label: '合格', value: '合格' },
        { label: '不合格', value: '不合格' }
      ],
      listQuery: {
        page: 1,
        limit: 20,
        report_number: '',
        equipment_name: '',
        client: '',
        inspection_result: '',
        stage: 5
      }
    }
  },
  created() {
    this.handleTable()
  },
  methods: {
    checkPermission,
    handleTable() {
      this.loading = true
      listSecurity(this.listQuery).then(response => {
        if (response && response.data) {
          this.list = response.data.data || []
          this.total = response.data.total || 0
        }
        this.loading = false
      }).catch((error) => {
        console.error('获取安全检验报告列表失败:', error)
        this.loading = false
        this.list = []
        this.total = 0
        this.$message.error('获取数据失败，请刷新重试')
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.handleTable()
    },
    handleDetail(row) {
      this.preview.id = row.id
      this.preview.data = row
      this.preview.isPrint = false
      this.preview.showRecord = true
      this.preview.dialogVisible = true
    },
    handleEditSecurity(row) {
      this.editSecurity.dialogVisible = true
      this.editSecurity.id = row.id
    },
    handlePrint(row) {
      this.preview.id = row.id
      this.preview.data = row
      this.preview.isPrint = true
      this.preview.showRecord = false
      this.preview.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSecurity(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.handleTable()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleEditSuccess() {
      this.editSecurity.dialogVisible = false
      this.handleTable()
    }
  }
}
</script>

<style scoped>

</style>
